window.theme = window.theme || {};


/**************************
  CUSTOM LANG SWITCHER
***************************/

var x, i, j, selElmnt, a, b, c;
/* Look for any elements with the class "custom-select": */
x = document.getElementsByClassName("ly-languages-switcher-zerance");
for (i = 0; i < x.length; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  /* For each element, create a new DIV that will act as the selected item: */
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected");
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  x[i].appendChild(a);
  /* For each element, create a new DIV that will contain the option list: */
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items select-hide");
  for (j = 1; j < selElmnt.length; j++) {
    /* For each option in the original select element,
    create a new DIV that will act as an option item: */
    c = document.createElement("DIV");
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.addEventListener("click", function(e) {
        /* When an item is clicked, update the original select box,
        and the selected item: */
        var y, i, k, s, h;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        h = this.parentNode.previousSibling;
        for (i = 0; i < s.length; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            y = this.parentNode.getElementsByClassName("same-as-selected");
            for (k = 0; k < y.length; k++) {
              y[k].removeAttribute("class");
            }
            this.setAttribute("class", "same-as-selected");
            break;
          }
        }
        h.click();
        $('#ly-languages-switcher').change();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function(e) {
    /* When the select box is clicked, close any other select boxes,
    and open/close the current select box: */
    e.stopPropagation();
    closeAllSelect(this);
    this.nextSibling.classList.toggle("select-hide");
    this.classList.toggle("select-arrow-active");
  });
}

function closeAllSelect(elmnt) {
  /* A function that will close all select boxes in the document,
  except the current select box: */
  var x, y, i, arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  for (i = 0; i < y.length; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i)
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < x.length; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}

/* If the user clicks anywhere outside the select box,
then close all select boxes: */
document.addEventListener("click", closeAllSelect);


/**************************
  MOBILE FILTER
***************************/

var mobileFilter = new function () {

  var settings = {
    toggleMobile : '[data-toggle-mobile-filter]',
    filterSelector : '[data-mobile-filter]',
    oneFilterSelector : '[data-toggle-one-filter]'
  }

  function mobileFilter() {
    $(settings.toggleMobile).on('click', function(){
      $(settings.toggleMobile).toggleClass('active');
      $(settings.filterSelector).slideToggle();
    });

    $(settings.oneFilterSelector).on('click', function() {
      $(this).parent().next().slideToggle();
      $(this).toggleClass('active');
    });
  }

  return mobileFilter;
}

var mobileFilter = new mobileFilter();


/**************************
  SEARCH
***************************/

theme.searchBar = new function() {

  var settings = {
    openSelector : '[data-search-bar-open]',
    closeSelector : '[data-search-bar-close], [data-search-bar-overlay]',
    searchBar : '[data-search-bar]',
    searchBarOverlay : '[data-search-bar-overlay]',
    inputBar : '[data-search-bar-input]',
    result : '[data-search-result]',
    resultProduct : '[data-search-result-product]',
    seeAll : '[data-search-see-all]',
    gridSearch : '[data-search-grid]',
    seeAllButton : '[data-search-seeall-button]',
    seeAllHide : '[data-search-hide]',
    resultArticle : '[data-search-result-article]',
    activeClass : 'active',
    activeSearchBodyClass : 'active-search',
    // most popular
    mostPopular : '[data-most-popular-search]'
  };

  var isMobile = false; //initiate as false
  // device detection
  if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
      || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
      isMobile = true;
  }


  function searchBar() {
    $(settings.inputBar).keyup(function( event ) {
      if (this.value.length > 1)
        search(this.value);
      else
        $(settings.result).removeClass(settings.activeClass);
    });
    $(settings.openSelector).on('click', function(e) {
      openSearch();
      return false;
    });
    $(settings.closeSelector).on('click', function() {
      closeSearch();
      $(settings.result).removeClass(settings.activeClass);
    });
    $(settings.mostPopular).on('click', function() {
      var mostPopularCurrent = $(this).html();

      $(settings.inputBar).val(mostPopularCurrent)
      search(mostPopularCurrent);
    });
    $(settings.resultProduct).on('click','.search-seeAll',function(e){
      e.preventDefault();
      $(settings.gridSearch).removeClass('grid__search');
      $(settings.result).removeClass('no-scroll-search');
      $(settings.seeAll).hide();
    });
  }

  function search(search) {
    ga('send', 'event', 'Search', 'keyup', 'Search', search);

    $.get('/search?view=ajax&q=' + search + '*&type=product', function( data ) {
      console.log(data);
      $(settings.resultProduct).html(data);
      if (isMobile) {
        $(settings.seeAll).show();
      } else {
        $(settings.seeAll).remove();
      }
      $(settings.result).addClass(settings.activeClass);
    });
    $.get('/search?view=ajax&q=' + search + '*&type=article', function( data ) {
      $(settings.resultArticle).html(data);
    });
  }


  function openSearch() {
    $(settings.searchBar).addClass(settings.activeClass);
    $('body').addClass(settings.activeSearchBodyClass);
    $(settings.inputBar).focus();
    $(settings.searchBarOverlay).fadeIn(500);
    $('body').addClass('stop-scrolling');
  }
  function closeSearch() {
    $(settings.searchBar).removeClass(settings.activeClass);
    $('body').removeClass(settings.activeSearchBodyClass);
    $(settings.searchBarOverlay).fadeOut(500);
    $('body').removeClass('stop-scrolling');
    // remove text in search bar
    $(settings.inputBar).val("");
  }


  return searchBar;
}

var searchBar = new theme.searchBar();


/**************************
  SLICK WRAPPER
***************************/


theme.slickCustom = new function() {

  var $carousel;

  function slickCustom(selector, selectorData) {

    // init default settings
    var settings = {
      selector: '[data-slick-slider]',
      selectorData : 'slick-slider'
    };

    if (selector && selectorData) {
      settings.selector = selector;
      settings.selectorData = selectorData;
    }

    // init flickity default settings
    var slickSettings = {

    };

    // iterate across all slider
    $(settings.selector).each(function() {
      var $currentEl = $(this);

      // get elements settings
      var elementSettings = $currentEl.data(settings.selectorData);

      // merge default settings with elements settings
      var finalSettings = $.extend({}, slickSettings, elementSettings);

      // init carousel
      $carousel = $currentEl.slick(finalSettings);

    });
  }

  // prev slide
  slickCustom.prototype.next = function() {
    if ($carousel) {
      $carousel.slick('slickNext');
    }
  }

  // next slide
  slickCustom.prototype.prev = function() {
    if ($carousel) {
      $carousel.slick('slickPrev');
    }
  }

  slickCustom.prototype.getCurrent = function() {
    if ($carousel) {
      return $carousel.slick('slickCurrentSlide');
    }
  }

  return slickCustom;
}

var slickCustom = new theme.slickCustom();


window.theme = window.theme || {};

/**************************
  COOKIE MANAGER
***************************/

function cookieManagerFunctions () {

  // set cookies like this : setCookie("username", user, 365);
  this.setCookie = function (cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  // getCookie like this : getCookie("username");
  this.getCookie = function (cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  return this;
}

const cookieManager = new cookieManagerFunctions();


/**************************
  QUIZZ STUDIO ZERANCE
***************************/

theme.quizz = new function() {

  var settings = {
    // slider settings
    sliderSelector: '[data-quizz-slider]',
    sliderSelectorData : 'quizz-slider',

    // quizz back button
    quizzBackButton : '[data-quizz-back-button]',

    // questions settings
    questionCta : '[data-quizz-cta]',
    questionsSelector : '[data-quizz-question]',
    questionInput : '[data-question-answer]',

    // breadcrumb
    breadcrumbLabel : '[data-breadcrumb-label]',
    breadcrumbLine : '[data-breadcrumb-line]',
    breadcrumbEmpty : '[data-breadcrumb-empty]',
    quizzNumber : '[data-quizz-number]',

    // multiple question
    multipleAnswer : '[data-quizz-multiple-answer]',
    answerNumber : '[data-answer-number]',
    answerRemove : '[data-answer-remove]',
    errorMessage : '[data-error-message]',
    minNumberAnswer : 2,
    maxNumberAnswer : 3,
  };

  var quizzSlider;
  var nbQuestion = 0;
  var answers = [];

  // multiple answer question
  var multipleAnswer = [];
  var indexAnswer = 1;

  var canSwape = true;


  function quizz() {
    // init slider quizz
    quizzSlider = new theme.slickCustom(settings.sliderSelector, settings.sliderSelectorData);

    $(settings.sliderSelector).on('afterChange', function(event, slick, direction){
      canSwape = true;
    });

    $(settings.sliderSelector).on('beforeChange', function(event, slick, direction){
      canSwape = false;
    });


    // init breadcrumb
    setTimeout(function(){ updateBreadcrumb(); }, 1000);

    // if first question is open, open keyboard
    if ($(settings.questionsSelector).eq(quizzSlider.getCurrent()).data('question-type') == "open-question") {
      $(settings.questionsSelector).eq(quizzSlider.getCurrent()).find('[data-question-answer]').focus().click();
    }

    $('[data-question-answer]').on('touchstart', function() {
     $(this).focus();
   });

    // on click on prev button, slide prev
    $(settings.quizzBackButton).on('click', function() {
      quizzPrev();
    });

    // check the number of question
    nbQuestion = $(settings.questionsSelector).length;

    // on click on validate button, go to the good function
    $('body').on('click', settings.questionCta, function() {
      var $question = $(settings.questionsSelector).eq(quizzSlider.getCurrent());
      checkQuestionAnswer($question, $(this).find('input[type="radio"]'));
      $(this).find('input[type="radio"]').prop( "checked", true );
      return false;
    });
    // on keypress on enter do the same
    $(document).on('keypress',function(e) {
      if (e.which == 13) {
        var $question = $(settings.questionsSelector).eq(quizzSlider.getCurrent());
        checkQuestionAnswer($question);
      }
    });

    // if question multiple
    $('body').on('click', settings.multipleAnswer, function(e){
      if ($(this).hasClass('active')) {
        console.log("je decheck", $(this).find('input[type="checkbox"]'));
        $(this).find('input[type="checkbox"]').prop( "checked", false );
        // if remove check the order and priority of answer
        var $question = $(settings.questionsSelector).eq(quizzSlider.getCurrent());
        var elVal = $(this).find($(settings.answerNumber)).html();

        $question.find(settings.multipleAnswer+'.active').each(function(){
          var currVal = $(this).find($(settings.answerNumber)).html();
          if (currVal > elVal) {
            $(this).find($(settings.answerNumber)).html(currVal - 1);
          }
        })
        // remove and fadeOut item
        $(this).removeClass('active');
        $(this).find($(settings.answerNumber)).fadeOut(0);
        $(this).find($(settings.answerRemove)).fadeOut(0);
        indexAnswer--;
      }
      else {
        console.log("je check", $(this).find('input[type="checkbox"]'));
        $(this).find('input[type="checkbox"]').prop( "checked", true );

        // if number max of answer is check
        if (indexAnswer > settings.maxNumberAnswer) {
          e.preventDefault();
          return false;
        }

        // active and fadeIn item
        $(this).addClass('active');
        $(this).find($(settings.answerNumber)).html(indexAnswer).fadeIn(100).css("display","inline-block");
        $(this).find($(settings.answerRemove)).fadeIn(100).css("display","inline-block");
        indexAnswer++;

      }

      // check if error message need to be display
      if (indexAnswer > 2)
        $(settings.errorMessage).fadeOut();

        return false;
    });

  }

  function quizzTrack(handleQuestion, handleAnswer) {
    if (ga) {
      ga('send', {
        hitType: 'event',
        eventCategory: 'quiz',
        eventAction: handleQuestion,
        eventLabel: handleAnswer
      });
    }
  }

  function checkQuestionAnswer($question, $answer) {
    switch ($question.data('question-type')) {
      case "open-question":
        verifyOpenQuestion($question);
        break;
        case "classic-question":
          if ($answer)
            verifyClassicQuestion($question, $answer);
          break;
        case "multiple-question":
          if ($answer)
            verifyMultipleQuestion($question);
          break;
      default:
        break;
    }
  }

  function verifyMultipleQuestion($question) {

    var $question = $(settings.questionsSelector).eq(quizzSlider.getCurrent());

    if ($question.find(settings.multipleAnswer+'.active').length < settings.minNumberAnswer) {
      $(settings.errorMessage).fadeIn();
      return;
    }

    else {
      $question.find(settings.multipleAnswer+'.active').each(function(){
        multipleAnswer[$(this).find(settings.answerNumber).html()] = $(this).find('input[type="checkbox"]').val();
        quizzTrack($(this).find(settings.answerNumber).html(), $(this).find('input[type="checkbox"]').val());
      });
      console.log(multipleAnswer);
      quizzNext();
    }

  }

  function verifyClassicQuestion($question, $answer) {
    // check if handle question exist, if true, stock value
    if ($question.data('question-handle') &&  $question.data('question-handle') != "") {
      answers[$question.data('question-handle')] = $answer.val();
      quizzTrack($question.data('question-handle'), $answer.val())
    }
    setTimeout(function(){
      if ($question.find("input:checked").length)
        quizzNext();
    }, 100);

  }

  function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  function verifyOpenQuestion($question) {

    // check if question have the required attribute
    var required = $question.attr('required');
    if (typeof required !== typeof undefined && required !== false) {
      if ($question.find(settings.questionInput).val() != "") {
        var handle = $question.data('question-handle');
        var val = $question.find(settings.questionInput).val();
        var exdays = 30;

        if (handle == "customer_mail" && !(validateEmail(val))) {
          alert("L'email n'est pas valide !");
          return;
        }
        val = val.replace(/é/gi, '22');
        val = val.replace(/ê/gi, '23');
        val = val.replace(/è/gi, '24');
        val = val.replace(/ë/gi, '25');
        val = val.replace(/ä/gi, '26');
        cookieManager.setCookie(handle, val, exdays);
        quizzNext();
      }
      // question cant be blank ! maybe add error mesasge ?
      return;
    }
    else {
      // question input can be blank
      quizzNext();
    }
  }

  function updateBreadcrumb() {
    var current = 1;
    // if slider is init, get the real value
    if (quizzSlider.getCurrent())
      current = quizzSlider.getCurrent() + 1;

    var total = $('.quizz [data-slick-index]').length;
    var percentage = Math.round((current / total) * 100);
    var percentage_invert = 100 - percentage;

    if (current <= 9) {
      current = "0" + current;
      $(settings.quizzNumber).removeClass('big');
    }
    else {
      $(settings.quizzNumber).addClass('big');
    }
    $(settings.quizzNumber).html(current);
    $(settings.breadcrumbLabel).html(percentage + " %");
    $(settings.breadcrumbLine).css('width', percentage + '%')
    $(settings.breadcrumbEmpty).css('width', percentage_invert + '%')
  }

  function quizzNext() {
    // if current question is the last, end of quizz and redirect
    if (quizzSlider.getCurrent() == (nbQuestion - 1)) {
      goToResult();
    }
    else {
      if (quizzSlider.getCurrent() == (nbQuestion - 2)) {
        $(settings.quizzNumber).fadeOut(0);
      }
      $('html, body').animate({ scrollTop: 50 }, 500);
      // if new question is auto slide, call the function
      if ($(settings.questionsSelector).eq(quizzSlider.getCurrent() + 1).data('question-type') == "auto-slide") {
        validateAutoQuestion();
      }
      if (canSwape)
        quizzSlider.next();
      else {
        var sI = setInterval(function(){
          if (canSwape) {
            quizzSlider.next();
            clearInterval( sI );
          }
        }, 200);
      }
      $(settings.quizzBackButton).fadeIn(100);
    }
    console.log(answers);
    updateBreadcrumb();
  }

  function validateAutoQuestion() {
    setTimeout(function(){
      quizzNext();
    }, 5000);
  }

  function quizzPrev() {
    $(settings.questionsSelector).eq(quizzSlider.getCurrent() - 1).find('.question__radio-container input').prop("checked", false);


    if (quizzSlider.getCurrent() > 0) {
      quizzSlider.prev();
      $('html, body').animate({ scrollTop: 50 }, 500);
      if (quizzSlider.getCurrent() == 0) {
        $(settings.quizzBackButton).fadeOut(100);
      }
    }
    else {
      $(settings.quizzBackButton).fadeOut(100);
    }
    updateBreadcrumb();
  }

  function goToResult() {
    var result = 0;
    var result_special_final = 0;
    var size = 0;

    for (var i in result_quizz){
      if (result_quizz.hasOwnProperty(i)) {
         var current = result_quizz[i];
         size = 0;
         for (var j in answers){
           if (answers.hasOwnProperty(j)) {
             if (current[j] == answers[j]) {
               size++;
               //console.log(current[j], answers[j], j, size, Object.keys(answers).length);
               if (size == Object.keys(answers).length) {
                 result = current;
               }
               continue;
             }
             else {
               break;
             }
           }
         }
       }
    }

    i = 0;
    j = 0;
    for (var i in result_special){
      if (result_special.hasOwnProperty(i)) {
         var current = result_special[i];
         size = 0;
         for (var j in multipleAnswer){
           if (multipleAnswer.hasOwnProperty(j)) {
             if (current[j] == multipleAnswer[j]) {
               size++;
               //console.log(current[j], multipleAnswer[j], j, size, Object.keys(multipleAnswer).length);
               if (size == Object.keys(multipleAnswer).length) {
                 result_special_final = current;
               }
               continue;
             }
             else {
               break;
             }
           }
         }
       }
    }
    //console.log(result);
    //console.log(result_quizz);
    //console.log(result_special);
    //console.log(multipleAnswer);

    // redirect to result page
    var rand = Math.floor(Math.random() * 10000);
    //console.log(encodeURI(JSON.stringify(result)));
    //console.log(result_special_final);
    window.location.href = "/pages/resultat-diagnostique?result=" +  encodeURI(JSON.stringify(result)) + "&result_special=" + encodeURI(JSON.stringify(result_special_final)) + "&cache=false&q=" + rand;
  }

  return quizz;
}

if ($('[data-section-type="quizz-zerance"]').length > 0)
  var quizz = new theme.quizz();


  /**************************
    Collapse WRAPPER
  ***************************/


  theme.collapseInfo = new function() {

    function collapseInfo() {

      // init default settings
      var settings = {
        selector: '[data-collapse-info]'
      };

      $(settings.selector).on('click', function() {
        $(this).toggleClass("protocole__product_active");
        var content = $(this).next();
        console.log(content.css('max-height'));

        if (!$(this).hasClass("protocole__product_active")){
          $(this).html('En savoir plus');
          content.css('max-height', '0');
        } else {
          $(this).html('Réduire');
          content.css('max-height', '1000px');
        }
      });
    }

    return collapseInfo;
  }

  var collapseInfo = new theme.collapseInfo();

  /**************************
    SLICK Only mobile
  ***************************/


  theme.slickOnlyMobile = new function() {

    var $carousel;

    function slickOnlyMobile() {

      // init default settings
      var settings = {
        selector: '[data-slick-slider-mobile]',
        selectorChild: '[data-slick-slider-mobile-item]',
        selectorData : 'slick-slider-mobile'
      };

      // init flickity default settings
      var slickSettings = {

      };

      $(settings.selectorChild).each(function() {
        var $currentEl = $(this);
        if ($currentEl.hasClass('grid__item')) {
          $currentEl.removeClass('grid__item')
        }
      });

      // iterate across all slider
      $(settings.selector).each(function() {
        var $currentEl = $(this);
        if ($currentEl.hasClass('grid')) {
          $currentEl.removeClass('grid')
        }

        // get elements settings
        var elementSettings = $currentEl.data(settings.selectorData);

        // merge default settings with elements settings
        var finalSettings = $.extend({}, slickSettings, elementSettings);
        // init carousel
        $carousel = $currentEl.slick(finalSettings);

      });
    }

    // prev slide
    slickOnlyMobile.prototype.next = function() {
      if ($carousel) {
        $carousel.slick('slickNext');
      }
    }

    // next slide
    slickOnlyMobile.prototype.prev = function() {
      if ($carousel) {
        $carousel.slick('slickPrev');
      }
    }

    slickOnlyMobile.prototype.getCurrent = function() {
      if ($carousel) {
        return $carousel.slick('slickCurrentSlide');
      }
    }

    return slickOnlyMobile;
  }

  var isMobile = false; //initiate as false
  // device detection
  if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
      || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
      isMobile = true;
  }

  if (isMobile) {
    var slickOnlyMobile = new theme.slickOnlyMobile();
  }


  /**************************
    Banner
  ***************************/

  theme.banner = new function() {

  var settings = {};

  function banner(bannerSettings) {

    var defaultSettings = {
      headerSelector : '#shopify-section-header',
      bannerSelector : '[data-banner]',
      selectorData : 'banner',
      prevNextButtons : false,
      pageDots : false,
      autoPlay : false
    };

    $(document).ready(function(){
      resizeWindow();
    });

    window.addEventListener('resize', function () {
      resizeWindow();
    });

    settings = $.extend({}, defaultSettings, bannerSettings);

    $(settings.bannerSelector).each(function() {

      var el = $(this);

      $(this).imagesLoaded( function() {
        var elementSettings = $(el).data(settings.selectorData);
        var finalSettings = $.extend({}, settings, elementSettings);

        $(el).flickity({
          lazyLoad: 'true',
          pageDots: finalSettings.pageDots,
          prevNextButtons: finalSettings.prevNextButtons,
          autoPlay: finalSettings.autoPlay
        });
      });

    });
  }

  function resizeWindow() {
    var windowWidth = window.innerWidth,
        headerSection = $(settings.headerSelector);

    document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px');
    if (headerSection) {
      document.documentElement.style.setProperty('--header-height', headerSection.height() + 'px');
    }
  };

  return banner;
}

var banner = new theme.banner();

/**************************
  Banner Header homepage
***************************/

var userScroll = $(document).scrollTop();

window.onscroll = function (e) {
  var newScroll = $(document).scrollTop();
  if(userScroll - newScroll > 20 || newScroll - userScroll > 20){
    $('.template-index header').addClass('header-scroll');
  }
}

/**************************
  Video Product
***************************/



theme.videoVimeo = new function() {

  function videoVimeo() {

    var settings = {
      imgSelector : '[data-video-play-cover]',
      selectorData : 'video-play-cover'
    };

    $(settings.imgSelector).each(function() {
      var el = $(this);
      var idVideo = 'video-product-presentation-' + el.data(settings.selectorData);
      el.on('click', function() {
        //var iframe = $(this).next('.video-wrapper').children();
        var iframe = document.getElementById(idVideo);
        // $f == Froogaloop
        var player = $f(iframe);
        $(this).addClass('hidden');
        player.api('play');
      });

    });
  }

  return videoVimeo;
}

var videoVimeo = new theme.videoVimeo();

/**************************
Out Of Stock
***************************/



window.addEventListener("klaviyoForms", function(e) {
  if (e.detail.type == 'submit') {
    $(".alert_me").addClass("no_show");
 }
});
